import Vue from "vue";

/**
 * 处理res
 * @param res
 * @returns {boolean}
 */
const isSuccess = (res) => {
    if (res.meta.code === "2") {
        Vue.prototype.$message.warning({
            showClose: true,
            message: res.meta.msg
        })
        return false
    } else if (res.meta.code === "0") {
        Vue.prototype.$message.error({
            showClose: true,
            message: res.meta.msg
        })
        return false
    }
    return true
}

/**
 * 处理res
 * @param res
 * @returns {boolean}
 */
const isFailure = (res) => {
    if (typeof res.meta === 'undefined') {
        Vue.prototype.$message.error({
            showClose: true,
            message: "返回数据异常！"
        })
        return true
    }
    if (res.meta.code === "2") {
        Vue.prototype.$message.warning({
            showClose: true,
            message: res.meta.msg
        })
        return true
    } else if (res.meta.code === "0") {
        Vue.prototype.$message.error({
            showClose: true,
            message: res.meta.msg
        })
        return true
    }
    return false
}

/**
 * 提示成功
 * @param res
 */
const msgSuccess = (res) => {
    if (res.meta.code === "1") {
        Vue.prototype.$message.success({
            showClose: true,
            message: res.meta.msg
        })
    }
}

//非递归
const resetInfo = (info) => {
    for (let [key, value] of Object.entries(info)) {
        if (typeof value === 'string') {
            info[key] = ''
        } else if (typeof value === 'number') {
            info[key] = 0
        } else if (typeof value === 'boolean') {
            info[key] = false
        } else if (typeof value === 'object') {
            if (value instanceof Array) {
                info[key] = []
            } else {
                info[key] = {}
            }
        }
    }
    return info
}

//递归
const resetInfo2 = (info) => {
    for (let [key, value] of Object.entries(info)) {
        if (typeof value === 'string') {
            info[key] = ''
        } else if (typeof value === 'number') {
            info[key] = 0
        } else if (typeof value === 'boolean') {
            info[key] = false
        } else if (typeof value === 'object') {
            if (value instanceof Array) {
                info[key] = []
            } else {
                info[key] = resetInfo2(value)
            }
        }
    }
    return info
}


export {
    isFailure,
    isSuccess,
    msgSuccess,
    resetInfo
}
